import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { withTracking } from '../../../observability';
import { SimpleCTA } from './SimpleCTA';

export default createBuilderModule(
  withChildren(withTracking(SimpleCTA, { sectionName: 'SimpleCTA' })),
  {
    name: 'SimpleCTA',
    inputs: [
      {
        name: 'heading',
        type: 'string',
        required: true,
      },
      {
        name: 'buttons',
        type: 'list',
        subFields: [
          {
            name: 'variant',
            type: 'string',
            enum: ['primary', 'primary-alt', 'secondary'],
            defaultValue: 'primary',
          },
          {
            name: 'text',
            type: 'string',
          },
          {
            name: 'url',
            friendlyName: 'URL',
            type: 'string',
          },
        ],
      },
      {
        name: 'disableSpacing',
        type: 'boolean',
      },
    ],
  },
);
